<template>
    <Modal v-model="show"
        title="账号信息"
        :width="60"
        @on-visible-change="onShowChange">
        <Spin v-if="$globalSpin"
            size="large"
            fix></Spin>
        <Form ref="userFinanceForm"
            :model="userFinanceForm"
            :rules="ruleValidate"
            label-position="top"
            class="small-form">

            <Row :gutter="16">
                <Col span="6">
                <FormItem label="登录帐号"
                    prop="userName">
                    <Input v-model="userFinanceForm.userName"
                        :readonly="formEditMode===FORM_EDIT_MODE_MODIFY"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="姓名"
                    prop="userFinanceName">
                    <Input v-model="userFinanceForm.userFinanceName"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="手机"
                    prop="userFinancePhone">
                    <Input v-model="userFinanceForm.userFinancePhone"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="审批">
                    <RadioGroup v-model="userFinanceForm.userFinanceApproval"
                        type="button">
                        <Radio v-for="item in approvalSource"
                            :key="item.val"
                            :label="item.val">{{ item.label }}
                        </Radio>
                    </RadioGroup>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="6">
                <FormItem label="主账号">
                    <RadioGroup v-model="userFinanceForm.isPrimaryAccount"
                        type="button">
                        <Radio v-for="item in primaryAccountSource"
                            :key="item.val"
                            :label="item.val">{{ item.label }}
                        </Radio>
                    </RadioGroup>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE"
                    span="6">
                <FormItem label="密码">
                    <Input v-model="password"
                        type="password"></Input>
                </FormItem>
                </Col>
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE"
                    span="6">
                <FormItem label="密码确认">
                    <Input v-model="passwordConfirm"
                        type="password"></Input>
                </FormItem>
                </Col>
            </Row>
        </Form>
        <div slot="footer">
            <Button type="primary"
                @click="onSave">确认</Button>
            <Button type="error"
                @click="show=false">取消</Button>
        </div>
    </Modal>
</template>

<script>
import { APPROVAL_NO, APPROVAL_YES, approvalFormat } from '@/libs/baseModelFormat';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';

import { financeUserSave, getFinanceUserDetail } from '@/api/modules/account-management/finance-user-management';

export default {
    name: 'FinanceUserEdit',
    data() {
        return {
            show: false,
            accountUuid: '',
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            userFinanceForm: {
                userFinanceLoginUuid: '',
                userName: '',
                userFinanceName: '',
                userFinanceContactNumber: '',
                userFinancePhone: '',
                userFinanceWechat: '',
                userFinanceEmail: '',
                isPrimaryAccount:0,
                userFinanceApproval: APPROVAL_NO
            },
            ruleValidate: {
                userName: [
                    {
                        trigger: 'blur',
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                if (value.length >= 3 && value.length <= 20) {
                                    callback();
                                }
                                else {
                                    callback(new Error('长度在3-20个字符之间'));
                                }
                            }
                            else {
                                callback(new Error(' '));
                            }
                        }
                    }
                ],
                userFinanceName: [
                    {
                        trigger: 'blur',
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                if (value.length >= 2 && value.length <= 20) {
                                    callback();
                                }
                                else {
                                    callback(new Error('长度在2-20个字符之间'));
                                }
                            }
                            else {
                                callback(new Error(' '));
                            }
                        }
                    }
                ],
                userFinancePhone: [
                    { pattern:/^(?:(?:\+|00)86)?1\d{10}$/, required: true, message: '手机号码格式不正确1 ', trigger: 'change' }
                ]
            },
            password: '',
            passwordConfirm: '',
            approvalSource: [],
            primaryAccountSource: []
        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(accountUuid) {
            this.accountUuid = accountUuid;
            this.show = true;
        },
        init() {
            this.approvalSource = [];
            this.approvalSource.push({ val: APPROVAL_NO, label: approvalFormat(APPROVAL_NO) });
            this.approvalSource.push({ val: APPROVAL_YES, label: approvalFormat(APPROVAL_YES) });
            this.primaryAccountSource = [ { val: 0, label: "子账号" }, { val: 1, label: "主账号" }]; 

            // const query = this.$route.query;
            if (this.accountUuid) {
                this.formEditMode = FORM_EDIT_MODE_MODIFY;

                // this.$showGlobalSpin();
                getFinanceUserDetail(this.accountUuid).then(res => {
                    this.$hideGlobalSpin();
                    if (res.code === 0) {
                        const info = res.data.userFinance;
                        this.userFinanceForm.userFinanceLoginUuid = info.userFinanceLoginUuid;
                        this.userFinanceForm.userName = info.userName;
                        this.userFinanceForm.userFinanceName = info.userFinanceName;
                        this.userFinanceForm.userFinanceContactNumber = info.userFinanceContactNumber;
                        this.userFinanceForm.userFinancePhone = info.userFinancePhone;
                        this.userFinanceForm.userFinanceWechat = info.userFinanceWechat;
                        this.userFinanceForm.userFinanceEmail = info.userFinanceEmail;
                        this.userFinanceForm.userFinanceApproval = info.userFinanceApproval;
                        this.userFinanceForm.isPrimaryAccount = info.isPrimaryAccount;
                    }
                }).catch(() => {
                    this.$hideGlobalSpin();
                });
            }
            else {
                this.$refs.userFinanceForm.resetFields();
            }
        },
        onSave() {
            this.$refs.userFinanceForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('表单验证失败!');
                    return;
                }

                const data = Object.assign({ formEditMode: this.formEditMode }, this.userFinanceForm);
                if (this.formEditMode === FORM_EDIT_MODE_CREATE) {
                    data.password = this.password;
                    data.passwordConfirm = this.passwordConfirm;
                }

                this.$showGlobalSpin();
                financeUserSave(data).then(res => {
                    this.$hideGlobalSpin();
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            onOk: () => {
                                this.show = false;
                                this.$parent.getFinanceUserTableRecords();
                            }
                        });
                    }
                });
            });
        }
    }
};
</script>

<style scoped>
</style>
